<template>
	<ViewFeedItem class="view-feed-venuenewnearby">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="Fresh places to play">
				<RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				v-bind:useLocation="true"
				v-bind:venueCollection="venueCollection"
				v-on:venue:select="Handle_OnSelectVenue"
				view="horizontal"
			/>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * Location change + fetch is handled by the List component.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedVenueNewNearby extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/Venue
		 */
		public venueCollection: ChalkySticks.Collection.Venue = ChalkySticks.Factory.Venue.collection({
			limit: 8,
			qp: {
				order: 'newest',
			},
		});

		/**
		 * @return void
		 */
		@mounted
		public setup(): void {
			this.venueCollection.fetch();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-venuenewnearby {
		--chalky-utility-gallery-aspect-ratio: 4 / 3;

		.chalky.venue-list.view-horizontal .list {
			padding-bottom: 1rem;
		}
	}
</style>
